import jQuery from 'jquery';
let $ = jQuery;

import "./Widget.js";
    
/**
    * class HSN.Widget.FlexPayProcessPayments
    *
    * Encapsulates the common functionality of the FlexPayProcessPayments Widget.
    **/
HSN.Widget.FlexPayProcessPayments = function () {
    var application;
    var container;
    var accountService;
    var deviceInformation;
    var orderIdentity;
    var paymentNumbers;
    /**
        * new HSN.Widget.FlexPayProcessPayments.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.FlexPayProcessPayments]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        accountService = application._getAccountService();
        deviceInformation = application.DeviceInformation;
        orderIdentity = config.orderIdentity;
        paymentNumbers = config.paymentNumbers;

        bindEvents();
    }

    function startProcessing() {
        processPayment(0);
    }

    function bindEvents() {
        container.on('click', '.return-to-flexpay', function () {
            application.Events.Trigger(HSN.Widget.FlexPayProcessPayments.EVENT.RETURN_TO_MANAGER);
            return false;
        });
    }

    function processPayment(index) {
        if(index < paymentNumbers.length) {
            updateStatus(paymentNumbers[index], 'processing');
            accountService.SubmitFlexPayment({ orderIdentity : orderIdentity, flexPaymentNumber : paymentNumbers[index] }, {
                callback : function(data) {
                    if(data.success) {
                        updateStatus(paymentNumbers[index], 'charged');
                        //Only recurse if everything was successful 
                        processPayment(index + 1);
                    }
                    else {
                        //Insert error before line that caused it
                        HSN.AddErrorTreatment($('.payment-line-' + paymentNumbers[index], container), data);
                        updateStatus(paymentNumbers[index], 'error');
                        application.Events.Trigger(HSN.Widget.FlexPayProcessPayments.EVENT.ERROR);
                        showErrorMessage();
                    }
                },
                errorCallback : function () {
                    updateStatus(paymentNumbers[index], 'error');
                    application.Events.Trigger(HSN.Widget.FlexPayProcessPayments.EVENT.ERROR);
                    showErrorMessage();
                }
            });
        }
        else {
            application.Events.Trigger(HSN.Widget.FlexPayProcessPayments.EVENT.FINISHED);
            showSuccessMessage();
        }
    }

    function updateStatus(paymentNumber, status) {
        var payment = $('.payment-line-' + paymentNumber, container);
        $('.processing-status', payment).html(status);
        switch(status) {
            case 'processing':
                $('.processing-container', payment).toggle(true);
                $('.success-container', payment).toggle(false);
                $('.error-icon-container', payment).toggle(false);
                break;
            case 'charged':
                $('.processing-container', payment).toggle(false);
                $('.success-container', payment).toggle(true);
                $('.error-icon-container', payment).toggle(false);
                break;
            case 'error':
                $('.processing-container', payment).toggle(false);
                $('.success-container', payment).toggle(false);
                $('.error-icon-container', payment).toggle(true);
                break;
        }
    }
    function showSuccessMessage() {
        $('.success-message').toggle(true);
    }
    function showErrorMessage() {
        $('.error-message').toggle(true);
    }
    function Destroy() {
    }
    return {
        init: init,
        Destroy: Destroy,
        StartProcessing: startProcessing
    }
};

HSN.Widget.FlexPayProcessPayments.EVENT = {
    FINISHED: 'HSN.Widget.FlexPayProcessPayments:FINISHED',
    ERROR: 'HSN.Widget.FlexPayProcessPayments:ERROR',
    RETURN_TO_MANAGER: 'HSN.Widget.FlexPayProcessPayments:RETURN_TO_MANAGER'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/FlexPayProcessPayments.js